<template>
  <section class="flex flex-col gap-4 p-5">
    <section class="name-section flex flex-col gap-2">
      <label>
        {{ $i18nPresenter.t('Field name') }}
        <span class="text-red-50">*</span>
      </label>
      <aha-input
        v-model="field.name"
        :maxLength="100"
        hideCharacterCounter
        type="text"
        class="w-full"
        :placeholder="$i18nPresenter.t('e.g. Department, Team, Age')"
      />
    </section>
    <section class="label-section flex flex-col gap-2">
      <label>
        {{ $i18nPresenter.t('Question shown to participants') }}
        <span class="text-red-50">*</span>
      </label>
      <aha-input
        v-model="field.label"
        :maxLength="100"
        hideCharacterCounter
        type="text"
        class="w-full"
        :placeholder="$i18nPresenter.t('e.g. What’s your department?')"
      />
    </section>
    <section class="required-section flex gap-2 items-center">
      <toggle-button
        v-model="field.required"
        :width="35"
        :height="20"
        :color="{
          checked: '#6A1EBB',
          unchecked: '#D3D7E1'
        }"
      />
      <label class="label-required">{{ $i18nPresenter.t('Required') }}</label>
    </section>
    <section class="action-section flex justify-end gap-4">
      <aha-antd-button
        name="cancel-add-participant-field"
        v-aha-emit-action
        variant="secondary"
        @click="$emit('cancel')"
      >
        {{ $i18nPresenter.t('Cancel') }}
      </aha-antd-button>
      <aha-antd-button
        name="create-participant-field"
        v-aha-emit-action
        variant="primary"
        :disabled="!isValid"
        @click="$emit('create', field)"
      >
        {{ $i18nPresenter.t('Add field') }}
      </aha-antd-button>
    </section>
  </section>
</template>
<script>
export default {
  data() {
    return {
      field: {
        name: '',
        label: '',
        required: false,
      },
    }
  },
  computed: {
    isValid() {
      return this.field.name && this.field.label
    },
  },
}
</script>
